class DropdownLegendHandler {
    constructor() {
      this.initialize();
    }
  
    initialize() {
      
      this.setupEventListeners();
      
      setTimeout(() => {
        
        this.updateDropdownLegends();
        
        setTimeout(() => this.updateDropdownLegends(), 500);
        setTimeout(() => this.updateDropdownLegends(), 1000);
        
        setTimeout(() => this.validateInitialState(), 200);
        setTimeout(() => this.validateInitialState(), 1000);
      }, 300); // Wait for variant availability to finish
    }
  
    updateDropdownLegends() {
      
      const dropdownGroups = document.querySelectorAll('.product-options__option-group[data-option-type="dropdown"]');
      
      dropdownGroups.forEach(group => {
        this.updateGroupLegend(group);
      });
    }
  
    updateGroupLegend(group) {
      
      const selectedInput = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
      
      if (!selectedInput) return;
      
      const displayValue = this.getDisplayValue(selectedInput);
      
      this.updateLegendElements(group, displayValue);
    }
  
    getDisplayValue(selectedInput) {
      
      const optionElement = selectedInput.closest('.selectOption__option, .product-options__option-value');
      if (optionElement) {
        const textElement = optionElement.querySelector('.selectOption__value, .product-options__option-label');
        if (textElement) {
          return textElement.textContent.trim();
        }
      }
      
      return selectedInput.value;
    }
  
    updateLegendElements(group, value) {
    
      const legendValue = group.querySelector('.product-options__option-group-legend-value');
      if (legendValue) {
        legendValue.textContent = value;
      }
      
      const variantSelectedOptions = group.querySelectorAll('[variant-selected-option]');
      variantSelectedOptions.forEach(element => {
        element.textContent = value;
      });
      
      const dropdownButton = group.querySelector('.selectOption__select--text');
      if (dropdownButton) {
        dropdownButton.textContent = value;
      }
    }
  
    autoSelectColorBasedOnSize() {
      const variantDataScript = document.getElementById('product-options-variant-data');
      if (!variantDataScript) return;
  
      try {
        const productData = JSON.parse(variantDataScript.textContent);
        
        const colorIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color');
        const sizeIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');
        
        if (colorIndex === -1 || sizeIndex === -1) return;
  
        const sizeGroup = document.querySelector('.product-options__option-group--size');
        if (!sizeGroup) return;
  
        const selectedSizeInput = sizeGroup.querySelector('input[type="radio"]:checked');
        if (!selectedSizeInput) return;
  
        const selectedSize = selectedSizeInput.value;
  
        const availableColors = [];
        const unavailableColors = [];
  
        productData.variants.forEach((variant, idx) => {
          const variantSize = variant[`option${sizeIndex + 1}`];
          if (variantSize === selectedSize) {
            const color = variant[`option${colorIndex + 1}`];
            const metafields = productData.variants_metafields[idx];
            
            const isAvailable = metafields && 
              metafields.custom && 
              metafields.custom.availability !== false &&
              metafields.availability !== false;
  
            if (isAvailable) {
              if (!availableColors.includes(color)) {
                availableColors.push(color);
              }
            } else {
              if (!unavailableColors.includes(color)) {
                unavailableColors.push(color);
              }
            }
          }
        });
  
        const colorGroup = document.querySelector('.product-options__option-group--color');
        if (!colorGroup) return;
  
        const currentColorInput = colorGroup.querySelector('input[type="radio"]:checked');
        if (!currentColorInput) return;
  
        const currentColor = currentColorInput.value;
  
        if (unavailableColors.includes(currentColor) && availableColors.length > 0) {
          
          // Find and select the first available color
          const colorInputs = colorGroup.querySelectorAll('input[type="radio"]');
          colorInputs.forEach(input => {
            if (input.value === availableColors[0]) {
              input.checked = true;
              input.click();
              
              setTimeout(() => {
                this.updateColorDisplayText();
                this.updateVariantIdInput();
              }, 50);
            }
          });
        } else {
          
          setTimeout(() => {
            this.updateColorDisplayText();
            this.updateVariantIdInput();
          }, 50);
        }
      } catch (error) {
        console.error('[Auto Color Selection] Error:', error);
      }
    }
  
    autoSelectSizeBasedOnColor() {
      const variantDataScript = document.getElementById('product-options-variant-data');
      if (!variantDataScript) return;
  
      try {
        const productData = JSON.parse(variantDataScript.textContent);
        
        const colorIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'color');
        const sizeIndex = productData.options.findIndex(opt => opt.toLowerCase() === 'size');
        
        if (colorIndex === -1 || sizeIndex === -1) return;
  
        const colorGroup = document.querySelector('.product-options__option-group--color');
        if (!colorGroup) return;
  
        const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
        if (!selectedColorInput) return;
  
        const selectedColor = selectedColorInput.value;
  
        const availableSizes = [];
        const unavailableSizes = [];
  
        productData.variants.forEach((variant, idx) => {
          const variantColor = variant[`option${colorIndex + 1}`];
          if (variantColor === selectedColor) {
            const size = variant[`option${sizeIndex + 1}`];
            const metafields = productData.variants_metafields[idx];
            
            const isAvailable = metafields && 
              metafields.custom && 
              metafields.custom.availability !== false &&
              metafields.availability !== false;
  
            if (isAvailable) {
              if (!availableSizes.includes(size)) {
                availableSizes.push(size);
              }
            } else {
              if (!unavailableSizes.includes(size)) {
                unavailableSizes.push(size);
              }
            }
          }
        });
    
        const sizeGroup = document.querySelector('.product-options__option-group--size');
        if (!sizeGroup) return;
  
        const currentSizeInput = sizeGroup.querySelector('input[type="radio"]:checked');
        if (!currentSizeInput) return;
  
        const currentSize = currentSizeInput.value;
  
        if (unavailableSizes.includes(currentSize) && availableSizes.length > 0) {
          
          const sizeInputs = sizeGroup.querySelectorAll('input[type="radio"]');
          sizeInputs.forEach(input => {
            if (input.value === availableSizes[0]) {
              input.checked = true;
              input.click();
              
              setTimeout(() => {
                this.updateSizeDisplayText();
                this.updateVariantIdInput();
              }, 50);
            }
          });
        } else {
          
          setTimeout(() => {
            this.updateSizeDisplayText();
            this.updateVariantIdInput();
          }, 50);
        }
      } catch (error) {
        console.error('[Auto Size Selection] Error:', error);
      }
    }
    
    handleNoColorSelected() {
      const colorGroup = document.querySelector('.product-options__option-group--color');
      if (!colorGroup) return;

      const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
      if (selectedColorInput) return;

      const colorInputs = colorGroup.querySelectorAll('input[type="radio"]');
      for (let input of colorInputs) {
        if (!input.disabled && input.style.display !== 'none') {
          input.checked = true;
          input.click();
          break;
        }
      }
    }

    validateInitialState() {
      if (window.variantAvailability && window.variantAvailability.isProcessing) {
        setTimeout(() => this.validateInitialState(), 100);
        return;
      }
      
      this.handleNoColorSelected();
      
      this.autoSelectColorBasedOnSize();
      
      setTimeout(() => {
        this.autoSelectSizeBasedOnColor();
      }, 150);
      
      setTimeout(() => {
        this.updateColorDisplayText();
        this.updateSizeDisplayText();
        this.updateVariantIdInput();
      }, 200);
    }
  
    updateColorDisplayText() {
      const colorGroup = document.querySelector('.product-options__option-group--color');
      if (!colorGroup) return;
  
      const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
      if (!selectedColorInput) return;
  
      const selectedColor = selectedColorInput.value;
  
      const variantSelectedOptions = colorGroup.querySelectorAll('[variant-selected-option]');
      variantSelectedOptions.forEach(element => {
        element.textContent = selectedColor;
      });
  
      const legendValue = colorGroup.querySelector('.product-options__option-group-legend-value');
      if (legendValue) {
        legendValue.textContent = selectedColor;
      }
  
      const displayElements = colorGroup.querySelectorAll('.product-options__option-group-legend-value, [variant-selected-option]');
      displayElements.forEach(element => {
        element.textContent = selectedColor;
      });
    }
  
    updateSizeDisplayText() {
      const sizeGroup = document.querySelector('.product-options__option-group--size');
      if (!sizeGroup) return;
  
      const selectedSizeInput = sizeGroup.querySelector('input[type="radio"]:checked');
      if (!selectedSizeInput) return;
  
      const selectedSize = selectedSizeInput.value;
  
      const variantSelectedOptions = sizeGroup.querySelectorAll('[variant-selected-option]');
      variantSelectedOptions.forEach(element => {
        element.textContent = selectedSize;
      });
  
      const legendValue = sizeGroup.querySelector('.product-options__option-group-legend-value');
      if (legendValue) {
        legendValue.textContent = selectedSize;
      }
  
      const dropdownButton = sizeGroup.querySelector('.selectOption__select--text');
      if (dropdownButton) {
        dropdownButton.textContent = selectedSize;
      }
  
      const displayElements = sizeGroup.querySelectorAll('.product-options__option-group-legend-value, [variant-selected-option], .selectOption__select--text');
      displayElements.forEach(element => {
        element.textContent = selectedSize;
      });
    }
  
    updateVariantIdInput() {
      const variantDataScript = document.getElementById('product-options-variant-data');
      if (!variantDataScript) return;

      try {
        const productData = JSON.parse(variantDataScript.textContent);
        
        const colorGroup = document.querySelector('.product-options__option-group--color');
        const sizeGroup = document.querySelector('.product-options__option-group--size');
        
        if (!colorGroup || !sizeGroup) return;

        const selectedColorInput = colorGroup.querySelector('input[type="radio"]:checked');
        const selectedSizeInput = sizeGroup.querySelector('input[type="radio"]:checked');
        
        if (!selectedColorInput || !selectedSizeInput) return;

        const selectedColor = selectedColorInput.value;
        const selectedSize = selectedSizeInput.value;
        

        const correctVariant = productData.variants.find(variant => {
          return variant.option1 === selectedColor && variant.option2 === selectedSize;
        });

        if (correctVariant) {
          
          const variantIndex = productData.variants.findIndex(v => v.id === correctVariant.id);
          if (variantIndex !== -1) {
            const metafields = productData.variants_metafields[variantIndex];
            const isAvailable = !(
              (metafields && metafields.custom && metafields.custom.availability === false) ||
              (metafields && metafields.availability === false)
            );
            
            if (isAvailable) {
              const variantIdInput = document.querySelector('input[name="id"], select[name="id"]');
              if (variantIdInput) {
                variantIdInput.value = correctVariant.id;
                
                variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
              }

              const variantSelects = document.querySelectorAll('select[name="id"]');
              variantSelects.forEach(select => {
                const option = select.querySelector(`option[value="${correctVariant.id}"]`);
                if (option) {
                  select.value = correctVariant.id;
                }
              });
            }
          }
        } else {
        }
      } catch (error) {
        console.error('[Update Variant ID] Error:', error);
      }
    }
  
    setupEventListeners() {
      document.addEventListener('change', (event) => {
        const input = event.target;
        if (input.matches('input[type="radio"], input[type="checkbox"]')) {
          const dropdownGroup = input.closest('.product-options__option-group[data-option-type="dropdown"]');
          if (dropdownGroup) {
            this.updateGroupLegend(dropdownGroup);
          }
  
          const sizeGroup = input.closest('.product-options__option-group--size');
          if (sizeGroup && input.checked) {
            this.updateSizeDisplayText();
            
            setTimeout(() => {
              this.updateVariantIdInput();
            }, 50);
            
            setTimeout(() => {
              this.autoSelectColorBasedOnSize();
            }, 100);
          }
  
          const colorGroup = input.closest('.product-options__option-group--color');
          if (colorGroup && input.checked) {
            this.updateColorDisplayText();
            
            setTimeout(() => {
              this.updateVariantIdInput();
            }, 50);
            
            // small delay
            setTimeout(() => {
              this.autoSelectSizeBasedOnColor();
            }, 100);
          }
        }
      });

      document.addEventListener('variant:initial-selection', (event) => {
        if (event.detail && event.detail.variant) {
          setTimeout(() => {
            this.updateDropdownLegends();
            this.validateInitialState();
          }, 100);
        }
      });

      document.addEventListener('variant:availability-updated', () => {
        setTimeout(() => {
          this.updateDropdownLegends();
          this.validateInitialState();
        }, 100);
      });
  
      document.addEventListener('variant:changed', () => {
        setTimeout(() => {
          this.updateDropdownLegends();
          this.validateInitialState();
        }, 200); 
      });
  
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.updateDropdownLegends();
          this.validateInitialState();
        }, 100);
      });
  
      // Listen for window load
      window.addEventListener('load', () => {
        setTimeout(() => {
          this.updateDropdownLegends();
          this.validateInitialState();
        }, 100);
      });
  
      setInterval(() => {
        this.updateDropdownLegends();
        this.validateInitialState();
      }, 2000);
    }
  }
  
  window.dropdownLegendHandler = new DropdownLegendHandler();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.dropdownLegendHandler);
  } else {
    window.dropdownLegendHandler;
  } 